import { Link } from '@wg/wows-react-uikit'
import { openUrlInExternalBrowser } from 'fe2/web2ClientAPI/base'
import { t, x } from 'helpers/localization'
import React, { PureComponent } from 'react'
import { Interpolate } from 'react-i18next'
import settings from "settings"

export interface I_Props {
    className: String,
}

class Terms extends PureComponent<I_Props, any> {
    constructor(props) {
        super(props)

        this.openTerms = this.openTerms.bind(this)
    }

    openTerms() {
        const isInGame = window.navigator.userAgent.indexOf(settings.ingameUserAgent) !== -1
        const url = 'https://wargaming.com/privacy/' // TODO почему тут урла зашита??
        if (isInGame)
            openUrlInExternalBrowser(url)
        else
            window.open(url, '_blank')
    }

    render() {
        const linkToTerms = (
            <Link
                arrow=""
                isActionLink
                onClick={this.openTerms} >
                {t('Политикой конфиденциальности Wargaming')}
            </Link>
        )

        return (
            <span className={this.props.className}>
                <Interpolate
                    useDangerouslySetInnerHTML={true}
                    i18nKey={x('В целях безопасности не указывайте здесь личную информацию о себе или о ком-либо другом, так как мы не сможем защитить её в соответствии с %(linkToTerms)s.')}
                    linkToTerms={linkToTerms}
                    parent={'p'}
                    t={t} />
            </span>
        )
    }
}

Terms.defaultProps = {
    className: '',
}

export default Terms